<template>
  <div>
    <!-- 考试选择器 -->
    <el-dialog title="批量选择试题" :visible.sync="isShow" width="70%" @submit.native.prevent>
      <el-form
        ref="form"
        :model="dataForm"
        label-width="80px"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="试题编号" prop="questionNo">
              <el-input v-model="dataForm.questionNo"  @keyup.enter.native="search"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="试题内容" prop="questionStemContent">
              <el-input v-model="dataForm.questionStemContent"  @keyup.enter.native="search"></el-input>
            </el-form-item>
          </el-col>
<!--          <el-col :span="6">
            <el-form-item label="目录" prop="directoryId">
              <selectTree
                :props="{
                  value: 'id', // ID字段名
                  label: 'directoryName', // 显示名称
                  children: 'directoryList' // 子级字段名
                }"
                :options="categoryList"
                :value="dataForm.questionsDirectoryId"
                clearable
                @getValue="selectTreeChange"
                ref="selectTree"
              ></selectTree>
            </el-form-item>
          </el-col>-->
          <el-col :span="3">
            <el-form-item>
              <el-button type="primary" @click="search">搜索</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 资源列表 -->
      <div v-loading="tableLoading" element-loading-text="拼命加载中" >
        <el-table :data="dataList" @selection-change="selectionChange" :row-key="getRowKeys" ref="multipleTable" v-if="isTableShow"  height="510">
          <el-table-column type="selection" :reserve-selection="true"></el-table-column>
          <el-table-column type="index" width="50" label="序号">
          </el-table-column>
          <el-table-column
            prop="questionNo"
            label="编号"
            width="200"
          ></el-table-column>
          <el-table-column prop="prop" label="题型" width="200">
            <template slot-scope="scope">{{
                scope.row.questionType == 1
                  ? "单选题"
                  : scope.row.questionType == 2
                  ? "多选题"
                  : scope.row.questionType == 3
                    ? "判断题"
                    : "无"
              }}
            </template>
          </el-table-column>
          <el-table-column label="试题内容">
            <template slot-scope="scope">
              <div v-html="scope.row.questionStemContent"></div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          style="margin-top:20px; float:right;"
          @size-change="sizeChange"
          :current-page="page"
          @current-change="pageChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <batchBox :title="'请选' + max + '道题'" :props="batchBoxProps" @selection-change="batchBoxChange" ref="batchBox" :max="max"></batchBox>
      <span slot="footer" style="text-align: center; margin-top: 30px" class="p10">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import examApi from "@/api/new/exam.js";
import batchBox from '@/pages/trainingManagement/component/batchBox.vue';
import selectTree from "@/components/common/selectTree";


export default {
  name: "librarySelector",
  components: {selectTree, batchBox},
  data() {
    return {
      isShow: false,
      dataForm: {
        questionBankId:undefined,
        questionNo: undefined,
        questionStemContent: undefined,
        trainingProgramId: undefined
      },
      categoryList: [],
      dataList: [],

      total: 0,
      pageSize: 10,
      page: 1,

      tableLoading: false,
      options: [],
      selectDataList: [],
      isTableShow: true,
      batchBoxProps: {
        value: 'id',      // ID字段名
        label: 'questionNo',   // 显示名称
      },
      currentQuestionType: undefined, // 当前试题类型

      max: 1 // 最大选择数量
    }
  },
  methods: {
    tableReload(){
      this.dataList = JSON.parse(JSON.stringify(this.dataList));
    },
    search(){
      this.page = 1;
      this.getDataList();
    },
    //获取资料列表
    getDataList() {
      let p = {
        ...this.dataForm,
        page: this.page,
        pageSize: this.pageSize,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId,
        questionType: this.currentQuestionType,
      };
      this.tableLoading = true;
      examApi.getQuestionBankList(p).then(res => {
          this.dataList = res.data.records;
          this.total = res.data.total;
          this.tableLoading = false;
        });
    },
    pageChange(e) {
      this.page = e;
      this.getDataList();
    },
    sizeChange(e) {
      this.pageSize = e;
      this.search();
    },
    selectTreeChange(v) {
      if (v.id){
        this.dataForm.directoryId = v.id;
        this.dataForm.directoryName = v.text;
      }  else {
        this.dataForm.directoryId = undefined;
        this.dataForm.directoryName =  undefined;
      }
    },
    //重置表单
    resetForm() {
      this.$refs.form.resetFields();
      //this.$refs.selectTree.clearHandle();
    },
    selectionChange(e) {
      console.log("selectionChange",e)
      this.selectDataList = e;
      this.$refs.batchBox.setSelection(e);
    },
    batchBoxChange(rows){
      if (this.selectDataList){
        this.$refs.multipleTable.clearSelection();
      }
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
        this.tableReload();
      }
    },
    setSelection(prarmQuestionBankId,rows, questionType, max){
      this.dataForm.questionBankId = prarmQuestionBankId ;
      this.currentQuestionType = questionType;
      this.max = max;
      this.$nextTick().then(() => {
        this.resetForm();
        this.search();
        this.$refs.multipleTable.clearSelection();
        if (rows) {
          rows.forEach(row => {
            if (row.questionsPaperId) {
              row.id = row.questionsPaperId;
            }
            this.$refs.multipleTable.toggleRowSelection(row);
          });
          this.tableReload();
        }
      });

      if (this.dataForm.questionBankId){
        console.log("this.dataForm.questionBankId",this.dataForm.questionBankId)
        this.search();
      }
    },
    show(){
      this.isShow = true;
    },
    getRowKeys(row){
      if (row.questionLibraryId) {
        return row.questionLibraryId;
      } else {
        return row.id;
      }
    },
    confirm() {
      if (this.max && this.selectDataList.length > this.max) {
        this.$message.error(`只能选择${this.max}个题目`);
        throw "error";
      }
      this.$emit("confirm", this.selectDataList);
      this.isShow = false;
    },

  },
  mounted() {
    examApi.getCatalogList({
      type: 1,
      enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
        .enterpriseId
    }).then(res => {this.categoryList = res.data;});
    this.getDataList();
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/component/librarySelector.vue